import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import * as shortuuid from "short-uuid";
import moment from "moment";

function NotSoSmartTableComponent({ settings, data }) {
    const [currentSort, setCurrentSort] = useState({ key: Object.keys(settings.columns)[0], sort: "desc" });
    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        setDataTable(sortArray(currentSort.key, data, currentSort.sort));
    }, [data, currentSort]);

    function sortArray(key, array, sortBy = "asc") {
        if (!Array.isArray(array)) return []; // Ensure array is valid
        return [...array].sort((a, b) => {
            let keyA = a[key], keyB = b[key];

            if (settings.columns[key]?.sortType === "dateFormat") {
                keyA = moment(keyA);
                keyB = moment(keyB);
                return sortBy === "asc" ? keyA - keyB : keyB - keyA;
            } else if (settings.columns[key]?.sortType === "number") {
                keyA = parseFloat(keyA) || 0;
                keyB = parseFloat(keyB) || 0;
                return sortBy === "asc" ? keyA - keyB : keyB - keyA;
            } else {
                keyA = keyA?.toString() || "";
                keyB = keyB?.toString() || "";
                return sortBy === "asc" ? keyA.localeCompare(keyB) : keyB.localeCompare(keyA);
            }
        });
    }

    return (
        <table className="table">
            <thead>
            <tr>
                {Object.keys(settings.columns).map((key) => (
                    <th key={key} onClick={() => setCurrentSort({ key, sort: currentSort.sort === "asc" ? "desc" : "asc" })}>
                        {settings.columns[key].title}
                    </th>
                ))}
            </tr>
            </thead>
            <tbody>
            {dataTable.map((row) => (
                <tr key={shortuuid.generate()}>
                    {Object.keys(settings.columns).map((key) => (
                        <td key={key}>
                            {settings.columns[key]?.sortType === "dateFormat"
                                ? moment(row[key]).format("YYYY-MM-DD") // ✅ Properly formats date
                                : settings.columns[key]?.valuePrepareFunction
                                    ? settings.columns[key].valuePrepareFunction(row[key])
                                    : row[key]}
                        </td>
                    ))}
                </tr>
            ))}
            </tbody>
        </table>
    );
}

NotSoSmartTableComponent.propTypes = {
    settings: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
};

export default NotSoSmartTableComponent;
